module.exports = __webpack_public_path__ + "img/mewtwo-min.f1008cd9.png";